export const selectAllCompanies = (state: any) => state?.getAllCompanies || [];
